<template>
	<div class="home">
		<Nav :currentPage='curpage'></Nav>
		<section>
			<img src="../../assets/images/logo_center.png" alt="" class="img_logo_center">
			<img src="../../assets/images/home_bkg.png" alt="" class="img_home_bkg">
			<div class="center_content">
				<p>
					厦门市东合信息技术有限公司成立于2012年，是专业从事互联网法律服务产品技术研发、法律服务资源整合、政府公共法律服务项目合作的智能解决方案提供商。公司专注于推动互联网、大数据、人工智能和法律服务深度融合，拥有多个自主知识产权产品和深厚的人工智能及大数据相关技术积累，致力于打造全维度立体化的智慧法律服务产品供应链。
				</p>
				<p>
					厦门市东合信息技术有限公司秉承“思想引领时代、专业服务用户”的价值观，积极构建以智慧法务为核心，助推“数字法治智慧司法”建设的赋能型智慧法务产业格局，以智慧法务践行者为使命。目前，公司已经成功研发多元化纠纷调解一站式服务平台、道路交通纠纷调解平台、公共法律服务云平台、AI+家庭律师、企业法务体检、知识产权综合法律一站式服务平台、AI法律机器人等几大产品。
				</p>
			</div>
		</section>
		<Footer></Footer>
	</div>
</template>

<script>
import Nav from 'components/nav.vue'
import Footer from 'components/footer-home.vue'
export default {
  name: 'About',
  data() {
    return {
      curpage: 'about'
    }
  },
  components: {
    Nav,
    Footer
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.home {
	width: 1200px;
	margin: 0 auto;
	section {
		width: 100%;
		padding: 75px 0 136px;
		margin: 0 auto;
		background: #f7f8f8;
		border-radius: 26px;
		text-align: center;
		position: relative;
		.img_logo_center {
			width: 226px;
			height: 84px;
		}
		.img_home_bkg {
			position: absolute;
			bottom: 0;
			left: 0;
			width: 800px;
			height: 482px;
			border-bottom-left-radius: 25px;
			opacity: 0.9;
		}
		.center_content {
			width: 722px;
			padding: 38px 50px;
			margin: 58px auto 0;
			box-sizing: border-box;
			background: #fff;
			border-radius: 25px;
			box-shadow: -3px 6px 7px 1px rgba(112, 111, 111, 0.29);
			text-align: left;
			font-size: 15px;
			line-height: 40px;
			color: #000;
			text-indent: 40px;
		}
	}
}
@media screen and (max-width: 998px) and (min-width: 768px) {
	.home {
		width: 910px;
	}
}
</style>
